import Vue from 'vue';
import { Image, Icon } from '@ymba/ym-ui';

// register globally
Vue.component('ym-icon', Icon);
Vue.component('ym-img', Image);
